import React from 'react';

import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from 'shared/context/AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'aside',
  place__DEPRECATED: 'offerCard',
  name__DEPRECATED: 'Brand_banner',
};
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'dbfka', p2: 'fkhj' };
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 433 };

export const TgbAsideBannerContainer: React.FC = () => {
  return (
    <AdfoxContextProvider
      bannerPlace="aside"
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      size={SIZE}
      pParams={P_PARAMS}
    >
      <AdfoxBanner />
    </AdfoxContextProvider>
  );
};
